@if (!messageBroadcastingService.hasMessagingNumber() && !messageBroadcastingService.getNumbersInProgress) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <mat-card appearance="outlined" style="margin-top: 30px">
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <p-message severity="warn">
              You must enable Message Broadcasting for the numbers you'd like to use for broadcasting.
              @if (hasPhoneNumbersEditRight) {
                <span> Go to your <a class="btn-link" routerLink="/phone-numbers/list">Phone Numbers</a>  to customize settings.</span>
              } @else {
                <span> Contact your company administrator to setup messaging number.</span>
              }
            </p-message>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}
<mat-drawer-container #mainContainer class="messaging-container" [style.height]="containerHeight"
                      *ngIf="messageBroadcastingService.hasMessagingNumber() && !messageBroadcastingService.getNumbersInProgress">
  <mat-drawer #threadsDrawer [mode]="sidenavMode" [opened]="showThreads" (opened)="onThreadsMenuOpened()">
    <div class="actions-container">
      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="isMobileView">
        <button type="button" mat-icon-button class="button-40" (click)="threadsDrawer.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-form-field class="selected-number-dropdown no-underline no-hint">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          [(ngModel)]="messageBroadcastingService.selectedMessagingNumber"
          (valueChange)="onPhoneNumberValueChange($event)">
          <mat-select-trigger>
            <span class="selected-number-name">{{ messageBroadcastingService.selectedMessagingNumber?.userName }}</span>
            <span
              class="selected-number light-text">{{ messageBroadcastingService.selectedMessagingNumber?.phoneNumber | phoneNumber }}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let option of messageBroadcastingService.messagingNumbers" [value]="option"
                      style="line-height: 1; height: 4em" class="selected-number-popup">
            <span style="font-weight: 600;font-size: 16px;line-height: 20px;">
              {{ option.userName }}
            </span>
            <span style="font-weight: normal; font-size: 13px; line-height: 16px; padding-left: 0; display: block"
                  [matBadge]="option.badge"
                  [matBadgeHidden]="!option.badge || option.badge <= 0"
                  matBadgePosition="after"
                  matBadgeColor="warn">
              {{ option.phoneNumber | phoneNumber }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="hasEditAccess && messageBroadcastingService.selectedMessagingNumber?.allowSend">
        <button type="button" mat-flat-button color="primary" class="compose-btn" (click)="onNewBroadcast($event)">
          <mat-icon>add_circle</mat-icon>
          <span>Compose A Broadcast</span>
        </button>
      </div>

      <mat-form-field class="sms-search-field no-underline" appearance="outline">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" placeholder="Search message" autocomplete="off" [(ngModel)]="searchTextInternal"
               (input)="onSearchTextChange($event.target['value'])">
        <a mat-icon-button type="button" *ngIf="searchText" matSuffix aria-label="Clear" class="button-40"
           (click)="clearSearch($event)">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
    </div>

    <div class="threads-container">
      <app-broadcast-phone-number-group #broadcastPhoneNumberGroup
                                        [selectedBroadcastId]="routedBroadcastId"
                                        [selectedNumber]="routedPhoneNumber"
                                        [searchText]="searchText"
                                        (selectedThreadChangeEvent)="onSelectedThreadChanged($event)"
      ></app-broadcast-phone-number-group>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <form class="messages-form" [formGroup]="form" novalidate>
      <div class="messages-container" fxLayout="column" [ngClass]="{'is-mobile-view': isMobileView}">
        <div class="messages-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px"
             fxLayoutGap.xs="0" *ngIf="!!selectedGroup">
          <button type="button" mat-icon-button class="button-40 rect-btn active-accent"
                  *ngIf="isMobileView" (click)="threadsDrawer.toggle()" fxFlexOrder="1">
            <mat-icon>menu_open</mat-icon>
          </button>

          <label fxLayout="column" fxLayoutAlign="start start"
                 fxFlex fxFlex.xs="100" fxFlexOffset.xs="0px"
                 fxLayoutGap="2px" fxFlexOrder="2" fxFlexOrder.xs="3">
            <span>{{ selectedGroup?.name }}</span>
            <span class="broadcast-summary" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
              <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-spinner *ngIf="loadingContactsTotal" diameter="16"></mat-spinner>
                <span *ngIf="!loadingContactsTotal">{{ selectedGroup?.totalContacts }}</span>
                <span>contacts</span>
              </span>
              <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-spinner *ngIf="loadingContactsTotal" diameter="16"></mat-spinner>
                <span *ngIf="!loadingContactsTotal">{{ selectedGroup?.totalTags }}</span>
                <span>tags</span>
              </span>
              <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-spinner *ngIf="loadingContactsTotal" diameter="16"></mat-spinner>
                <span
                  *ngIf="!loadingContactsTotal">{{ selectedGroup?.totalTagContacts + selectedGroup?.totalContacts }}</span>
                <span>total contacts</span>
              </span>
              <span *ngIf="selectedGroup?.totalUnsubscribed > 0">
                <a (click)="showUnsubscribedList()">{{ selectedGroup?.totalUnsubscribed }} unsubscribed</a>
              </span>
              <span *ngIf="hasEditAccess && messageBroadcastingService.selectedMessagingNumber?.allowSend">
                | <a (click)="editBroadcast(selectedGroup?.id)">Edit broadcast</a>
              </span>
            </span>
          </label>
          <button mat-icon-button color="warn" class="button-40 rect-btn active-warn" type="button"
                  matTooltip="Delete Broadcast"
                  fxFlexOrder="3"
                  fxFlexOrder.xs="2"
                  (click)="onDeleteClick()"
                  *ngIf="hasDeleteAccess && messageBroadcastingService.selectedMessagingNumber?.allowSend && !!selectedGroup && selectedGroup?.id">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="messages-holder" fxFlex>
          <app-broadcast-messages-grid
            [selectedPhoneNumber]="routedPhoneNumber"
            [selectedBroadcastId]="routedBroadcastId"
            [searchText]="searchText"
            [hasEditAccess]="hasEditAccess"
            (newBroadcastClick)="editBroadcast('new')"
          ></app-broadcast-messages-grid>
        </div>
        <div class="messages-actions">
          <div class="messages-footer"
               *ngIf="hasEditAccess && messageBroadcastingService.selectedMessagingNumber?.allowSend && selectedGroup?.id && !limitsReached">
            <div class="messages-form" fxLayout="column" fxLayoutGap="10px">
              <div class="preview-attachment" *ngIf="previewFileName"
                   fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start">
                <div fxFlex fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                  <img [src]="previewUrl" alt="preview" *ngIf="previewUrl">
                  <div>{{ previewFileName }}</div>
                </div>
                <button type="button" mat-icon-button class="button-40" (click)="removeAttachment()"
                        matTooltip="Remove attachment">
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <div class="actions-row" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                   [ngClass]="{'is-mobile-view': isMobileView}">

                <input #fileInput id="upload-mms" class="file-input" type="file" style="display: none"
                       (change)="fileChangeEvent($event)"
                       placeholder="Choose a file..." />

                <div fxFlex fxLayout="row" fxLayoutAlign="start center">
                  <mat-form-field appearance="outline" fxFlex class="message-text-field">
                    <textarea #textInput maxlength="2048"
                              matInput
                              [cdkTextareaAutosize]="true"
                              [cdkAutosizeMinRows]="1"
                              [cdkAutosizeMaxRows]="5"
                              formControlName="message"
                              (paste)="onFilePaste($event)"
                              (keypress)="msgKeyPress($event)" placeholder="Enter your message">
                    </textarea>
                  </mat-form-field>

                  <button mat-icon-button type="button" class="button-40" (click)="$event.preventDefault()"
                          style="position: relative" [matMenuTriggerFor]="messageActionsMenu">
                    <mat-icon>
                      add
                      <app-messaging-select-template-v2 #templateTrigger
                                                        style="visibility: hidden; height: 1px; width: 1px; position: absolute"
                                                        (selectedEvent)="onTemplateSelected($event)"></app-messaging-select-template-v2>
                      <mat-menu #messageActionsMenu="matMenu" class="custom-menu">
                        <button mat-menu-item type="button" (click)="fileInput.click()" fxLayout="row"
                                fxLayoutAlign="start center">
                          <mat-icon>attach_file</mat-icon>
                          Send Attachment
                        </button>
                        <button mat-menu-item type="button" (click)="templateTrigger.click()" fxLayout="row"
                                fxLayoutAlign="start center">
                          <mat-icon>quickreply</mat-icon>
                          Quick Reply
                        </button>
                      </mat-menu>
                    </mat-icon>
                  </button>
                </div>

                <button type="button" mat-icon-button class="button-40 rect-btn message-send-btn active" color="accent"
                        matTooltip="Preview and send message" (click)="previewBroadcastMessage()">
                  <mat-icon>visibility</mat-icon>
                </button>
              </div>
            </div>
            <div class="file-drop-area" appDroppable (dropped)="dropFile($event)">
              <div>Drop File Here</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-drawer-content>
</mat-drawer-container>
